import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { useState } from "react"
import { useStore } from "../../contexts/store"
import { Pod } from "../../shared/src/types/Pod"

import AddPod from "./AddPod"
import TrialDialog from "../TrialDialog"
import { Box, Button, Tooltip } from "@mui/material"


const NewPodButton = () => {
  const { t } = useTranslation()
  const { sessionStore } = useStore()
  const { session } = sessionStore
  const [ createNewPod, setCreateNewPod ] = useState<boolean>(false)
  const [ showUpgradeForm, setShowUpgradeForm] = useState<boolean>(false)
  const nofOwnPods = sessionStore.getOwnPods().length
  if (!session) return null

  return (
    <Box sx={{
      display: "grid",
      justifyItems: "end"
    }}>
      {(session.user.podLimit === 0) && (session.pods.length === 0) ?
        <Tooltip
            disableFocusListener
            disableHoverListener
            disableTouchListener
            open={true}
            title={
            <>
              <div style={{textAlign:'left', fontSize:16, cursor:'pointer'}} onClick={() => { setShowUpgradeForm(true) }}>
                {t('You currently have no pods and you cannot create pods of your own. If you are an instructor and want to test SHRIMP, you may click here to upgrade your account.')}
              </div>
            </>
          } arrow>
              <span onClick={() => { setShowUpgradeForm(true) }}><Button size="small" variant="outlined" disabled={session.user.podLimit <= nofOwnPods}>{t('Create New Pod')}</Button></span>
          </Tooltip>
        :
        <Tooltip
            title={
            <>
              <div style={{textAlign:'left', fontSize:16}}>
              {t('You can create {{nof}} more new pods', {nof: (session.user.podLimit - nofOwnPods)}) as string}
              </div>
            </>
          } arrow>
              <span><Button size="small" variant="contained" onClick={() => { setCreateNewPod(true) }} disabled={session.user.podLimit <= nofOwnPods}>{t('Create New Pod')}</Button></span>
        </Tooltip>
      }
      <AddPod open={createNewPod === true} handleClose={() => setCreateNewPod(false)} />
      <TrialDialog open={showUpgradeForm} handleClose={() => setShowUpgradeForm(false)} />
    </Box>
  )
}

export default observer(NewPodButton)
